import { CumulioDashboard } from '../models/dashboard.model';

export const refreshData = <T extends CumulioDashboard>(dashboardComponent: T, iframe: HTMLIFrameElement, itemId?: string): Promise<void> => {
  if (iframe) {
    iframe.contentWindow.postMessage(
      {
        action: 'refreshData',
        id: itemId ? itemId : null,
        _version: dashboardComponent.VERSION,
      },
      '*'
    );
    return Promise.resolve();

  }

  return Promise.reject(new Error('Cannot retrieve contentWindow.'));
};
